import InvoiceHelper from '@/helpers/invoiceHelper';

export const AuequitexMixins = {
  methods: {
    isRecourse(invoice) {
      return InvoiceHelper.isRecourse(invoice);
    },
    isReverse(invoice) {
      return InvoiceHelper.isReverse(invoice);
    },
    isNonRecourse(invoice) {
      return InvoiceHelper.isNonRecourse(invoice);
    },
    getFactoringType(invoice) {
      return InvoiceHelper.getFactoringType(invoice);
    },
    calculateRoiPercentage(invoice) {
      const scoring = invoice && Array.isArray(invoice.scorings) ? invoice.scorings[0] : null
      if (!scoring) {
        return 0
      }

      if (InvoiceHelper.isReverse(invoice)) {
        const finalRoiPercent = scoring.discount_in_percentage * 1 - scoring.investor_fee
        return Math.floor(finalRoiPercent * 100) / 100
      }

      const roi_percent = scoring.discount_in_percentage * 1 - scoring.fee_hive * 1 - scoring.investor_fee
      const roi = (scoring.amount / 100) * roi_percent
      const finalRoiPercent = roi * 100 / scoring.amount_with_discount

      return Math.floor(finalRoiPercent * 100) / 100
    },

    calculateRoiPercentageScoring(is_reverse, scoring) {

      if (is_reverse == 1) {
        const finalRoiPercent = scoring.discount_in_percentage * 1 - scoring.investor_fee
        return Math.floor(finalRoiPercent * 100) / 100
      }

      const roi_percent = scoring.discount_in_percentage * 1 - scoring.fee_hive * 1 - scoring.investor_fee
      const roi = (scoring.amount / 100) * roi_percent
      const finalRoiPercent = roi * 100 / scoring.amount_with_discount

      return Math.floor(finalRoiPercent * 100) / 100
    },
    dueDaysLeft(due_date) {
      const targetDate = new Date(due_date)
      const currentDate = new Date()
      const differenceInTime = targetDate.getTime() - currentDate.getTime()
      const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24))
      return differenceInDays >= 0 ? differenceInDays : 0
    },
    twoDecimalNumber(number) {
      return parseFloat(parseFloat(number).toFixed(2))
    },

    clientType(types = []) {
      const user = this.$store.state.auth.user;
      const userRole = user.user_role;

      return types.includes(userRole)
    }
  },
}